export enum BidvVirtualAccountServiceQueryKeys {
  GET_SERVICE_CODE = 'GET_SERVICE_CODE',
  LIST_VAS = 'LIST_VAS',
  GET_QR = 'GET_QR',
  GET_QR_WITH_AMOUNT = 'GET_QR_WITH_AMOUNT',
  INQUIRY = 'INQUIRY',
  SYNC_TRANSACTIONS = 'SYNC_TRANSACTIONS',
  EXPORT_VAS = 'EXPORT_VAS',
}
